import axios from 'axios'
import objUtil from '@/utils/object'
export default {
  /**
   * 开始项目计时
   * @param {*} params
   */
  startTiming (params) {
    // var paramsOption = ['name', 'matterPkId', 'taskPkId', 'workTypeId', 'startTime', 'manual']
    const clientId = objUtil.getBrowser() + new Date().getTime()
    const queryStr = objUtil.buildQuery(params)
    const url = `/taskserver/api/v2/timing/timing/startTiming?clientId=${clientId}&${queryStr}`
    return axios.post(url, {})
  },
  /**
   * 结束项目计时
   * @param {*} pkId 计时ID
   */
  stopTiming (pkId) {
    const clientId = objUtil.getBrowser() + new Date().getTime()
    const url = `/taskserver/api/v2/timing/timing/stopTiming?pkId=${pkId}&clientId=${clientId}`
    return axios.post(url, {})
  },
  /**
   * 获取正在进行的计时
   */
  getTiming () {
    return axios.get('/taskserver/api/v2/timing/timing/getRunningTiming')
  },
  /**
   * 查询用户能见的用户列表
   */
  searchByCreateUserId () {
    // return request.get('ilaw/api/v2/taskflow/member/serachByCreateUserId')
    return axios.get('/ilaw/api/v1/auth/get/members')
  },
  /**
   * 根据需要查询权限的对象id和权限类型获取权限
   * @param {*} userId 当前用户Id
   * @param {*} subjectid 需要查询对象的id
   * @param {*} type 类型
   */
  queryPermissionBySubject (userId, subjectid, type) {
    return axios.get(`/permission/api/v1/permission/engine/${userId}/getPmsStrings`, { subjectid, type })
  }
}
